// removed by extract-text-webpack-plugin
module.exports = {"root":"_1u6M5","title":"_1Upgj","homeBlock":"_3_Ik0","homeIcon":"_20uYq","classroomBlock":"_1Z7Hb","classroomIcon":"_3WfVM","qzcontBlock":"_W-SWq","qzcontIcon":"_1ro7m","sessionBlock":"_3jmAd","sessionIcon":"_xCrTn","firstShow":"_mc28b","sessionImage":"_17rqV","qzcontImage":"_29MJ7","classroomImage":"_2c_p1","homeImage":"_1YGwa","links":"_2txeE","link":"_3e_mA","ctaLink":"_1jiVR","arrowIcon":"_3iL6U"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/PromotionBlock/PromotionBlock.scss
// module id = 1487
// module chunks = 3